(() => {
  const header = document.querySelector('[data-rdr21-header]');
  if (!header) return;

  const announcement = document.querySelector('[data-announcement]');
  if (announcement) {
    const announcementItems = [...announcement.querySelectorAll('[data-announcement-item]')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (announcementItems.length > 1 && !reducedMotion.matches) {
      let activeAnnouncement = 0;
      const startAnnouncementCycle = () => {
        window.setTimeout(() => {
          announcementItems[activeAnnouncement].hidden = true;
          announcementItems[activeAnnouncement].classList.remove('is-active');
          activeAnnouncement = (activeAnnouncement + 1) % announcementItems.length;
          announcementItems[activeAnnouncement].hidden = false;
          announcementItems[activeAnnouncement].classList.add('is-active');
          startAnnouncementCycle();
        }, 5000);
      };
      startAnnouncementCycle();
    }
  }

  const menuItems = [...header.querySelectorAll('[data-mega-menu]')];
  const panels = [...header.querySelectorAll('[data-header-panel]')];
  const desktopMenu = window.matchMedia('(min-width: 901px)');
  let menuCloseTimer;
  const syncMegaState = () => {
    document.body.classList.toggle('rdr21-mega-open', desktopMenu.matches && menuItems.some((item) => item.open));
  };
  const closeHeaderPanels = (except) => {
    window.clearTimeout(menuCloseTimer);
    panels.forEach((panel) => {
      if (panel !== except) panel.open = false;
    });
    menuItems.forEach((item) => { item.open = false; });
    syncMegaState();
  };

  menuItems.forEach((item) => {
    item.querySelector(':scope > summary')?.addEventListener('click', (event) => {
      if (!window.matchMedia('(min-width: 901px)').matches || event.detail === 0 || !item.dataset.menuUrl) return;
      event.preventDefault();
      window.location.assign(item.dataset.menuUrl);
    });
    item.addEventListener('pointerenter', () => {
      window.clearTimeout(menuCloseTimer);
      if (desktopMenu.matches) {
        closeHeaderPanels();
        item.open = true;
        syncMegaState();
      }
    });
    item.addEventListener('focusin', () => {
      if (!desktopMenu.matches) return;
      closeHeaderPanels();
      item.open = true;
      syncMegaState();
    });
    item.addEventListener('pointerleave', () => {
      if (desktopMenu.matches && !item.contains(document.activeElement)) {
        menuCloseTimer = window.setTimeout(() => {
          item.open = false;
          syncMegaState();
        }, 260);
      }
    });
    item.addEventListener('toggle', syncMegaState);
  });

  panels.forEach((panel) => {
    panel.addEventListener('toggle', () => {
      if (panel.open) {
        menuItems.forEach((item) => { item.open = false; });
        panels.forEach((other) => { if (other !== panel) other.open = false; });
        syncMegaState();
      }
      if (panel.matches('.rdr21-search') && panel.open) {
        window.setTimeout(() => panel.querySelector('[data-predictive-search-input]')?.focus(), 40);
      }
      document.body.classList.toggle('rdr21-menu-open', panels.some((item) => item.open));
    });
  });

  header.querySelector('[data-search-close]')?.addEventListener('click', () => {
    const search = header.querySelector('.rdr21-search');
    if (search) search.open = false;
  });

  document.addEventListener('pointerdown', (event) => {
    if (!header.contains(event.target)) closeHeaderPanels();
  });

  desktopMenu.addEventListener('change', (event) => {
    if (!event.matches) closeHeaderPanels();
    syncMegaState();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openPanel = panels.find((panel) => panel.open);
    const openMenu = menuItems.find((item) => item.open);
    if (openPanel || openMenu) {
      event.preventDefault();
      closeHeaderPanels();
      (openPanel || openMenu)?.querySelector('summary')?.focus();
    }
  });

  const input = header.querySelector('[data-predictive-search-input]');
  const results = header.querySelector('[data-predictive-search-results]');
  const suggestions = header.querySelector('[data-search-suggestions]');
  if (!input || !results) return;

  let debounceTimer;
  let requestController;
  input.addEventListener('input', () => {
    window.clearTimeout(debounceTimer);
    requestController?.abort();
    const term = input.value.trim();
    if (term.length < 2) {
      results.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
      if (suggestions) suggestions.hidden = false;
      return;
    }

    debounceTimer = window.setTimeout(async () => {
      const url = new URL(results.dataset.endpoint, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('section_id', 'predictive-search');
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[options][unavailable_products]', 'hide');
      requestController = new AbortController();
      results.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, { signal: requestController.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`Predictive search: ${response.status}`);
        const markup = await response.text();
        const parsed = new DOMParser().parseFromString(markup, 'text/html');
        const searchResults = parsed.querySelector('#rdr21-predictive-results');
        results.innerHTML = searchResults ? searchResults.innerHTML : '';
        input.setAttribute('aria-expanded', String(results.childElementCount > 0));
        if (suggestions) suggestions.hidden = results.childElementCount > 0;
      } catch (error) {
        if (error.name !== 'AbortError') results.replaceChildren();
      } finally {
        results.removeAttribute('aria-busy');
      }
    }, 220);
  });
})();
